import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Listens for `{ type: 'NAVIGATE', url }` messages from the service worker.
 * Sent by sw.js on a `notificationclick` when an app window was already open —
 * the SW focuses the window, and we react-router-navigate to the incident URL.
 */
export const useServiceWorkerNavigation = (): void => {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;

    const handler = (event: MessageEvent) => {
      if (!event.data || event.data.type !== 'NAVIGATE') return;
      const url = event.data.url;
      if (typeof url !== 'string') return;
      try {
        const parsed = new URL(url, window.location.origin);
        if (parsed.origin !== window.location.origin) return;
        navigate(parsed.pathname + parsed.search + parsed.hash);
      } catch {
        // Ignore malformed URLs.
      }
    };

    navigator.serviceWorker.addEventListener('message', handler);
    return () => navigator.serviceWorker.removeEventListener('message', handler);
  }, [navigate]);
};
